import * as $ from 'jquery';
import { RowTemplateFactory } from '../structural/row/row-template-factory';

export class BoxesCommon {

    public static heightFix = () => {
        let windowWidth=$(window).width();
        $('.boxes-component').each((i,comp) => {
        let w = $(comp).find('.box-comp-cont:visible').eq(0).width();
            if(windowWidth<600){
                $(comp).find('.box-comp-cont .box-component').css('height','auto');
            }
            else{
                $(comp).find('.box-comp-cont .box-component').height(w);
            }
        
        });
    }

    public static spaceFixes(){
        $('.boxes-component').each((i,comp) => {
            let title = $(comp).find('> p.preheader');
            if(title.length>0 && !title.eq(0).hasClass('d-none')){
                let parent = $(comp).parent();
                if(parent.hasClass('block')){
                    parent.addClass('with-boxes-title');
                    if(parent.is(":last-child") ){
                        //no margin és small margin esetében 1 szint van 1 oszlopnál
                        let row = parent.closest('.row-component');
                        let nextRow;
                        if(row.parent().hasClass('col')){
                            //large margin esetén van még egy szint
                            row = row.parent().closest('.row-component');
                            nextRow = row.next('.row-component');
                        }
                        else{
                            //nomargin és small margin esetén ennyi volt
                            nextRow = row.next('.row-component');
                        }
                        if(nextRow.length>0){
                            let nextBoxes = nextRow.find('.box-component-without-title');
                            if(nextBoxes.length>0 && nextBoxes.eq(0).is(':first-child')){
                                nextBoxes.eq(0).addClass('box-topMarginFix');
                            }
                        }
                    }
                }
            }
        });
    }

     public static resizeFix = () => {
         $(window).resize(BoxesCommon.heightFix)
     }

}